module.exports = __webpack_public_path__ + "static/scale-model-of-gallagher-house.-in-chicago-illinois-9733e289bad9058df653b520d7653a96.png";